/* Blog homepage behaviour.
 *
 * Replaces the only Webflow interaction on the page that CSS cannot express on
 * its own: GSAP + ScrollTrigger firing the CTA star animation once it scrolls
 * into view. Webflow loaded three GSAP bundles to add a single class; this does
 * the same with an IntersectionObserver at the same threshold (the SVG's top
 * edge reaching 75% of the viewport height, i.e. the bottom 25% of the screen).
 *
 * The animation itself is the CSS keyframe stagger in assets/css/blog-home.css,
 * copied from the Webflow page's own inline <style>.
 *
 * No dependencies. Loaded deferred, on the home template only.
 */
(function () {
    'use strict';

    var star = document.querySelector('.anim-open-lines');
    if (!star) {
        return;
    }

    // Paths start at scaleX(0)/opacity:0, so anything that prevents the class
    // from being added has to reveal them instead of leaving a blank band.
    var reveal = function () {
        star.classList.add('is-static');
    };

    if (!('IntersectionObserver' in window)) {
        reveal();
        return;
    }

    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        reveal();
        return;
    }

    var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
            if (entry.isIntersecting) {
                entry.target.classList.add('is-animated');
                observer.unobserve(entry.target);
            }
        });
    }, {
        // Ignore the bottom 25% of the viewport, matching ScrollTrigger's
        // start: 'top 75%'.
        rootMargin: '0px 0px -25% 0px',
        threshold: 0
    });

    observer.observe(star);
}());
